/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, FC } from 'react';
import { ChevronRightIcon, ChevronDownIcon } from '@domain-group/fe-co-icon';
import * as styles from './collapsible.styles';

interface CollapsibleProps {
  collapsedIcon?: React.ReactElement;
  expandedIcon?: React.ReactElement;
  heading: string;
  subheading?: string;
  expanded?: boolean;
}

const Collapsible: FC<CollapsibleProps> = ({
  heading,
  subheading,
  collapsedIcon,
  expandedIcon,
  expanded,
  children,
}) => {
  const defaultCollapsedIcon = <ChevronRightIcon />;
  const defaultExpandedIcon = <ChevronDownIcon />;
  const [isExpanded, setIsExpanded] = useState(expanded ?? false);
  return (
    <>
      <div
        css={styles.collapsibleHeader(isExpanded)}
        onClick={() => setIsExpanded(!isExpanded)}
        onKeyPress={() => setIsExpanded(!isExpanded)}
      >
        <h4>
          {isExpanded ? (
            <>{expandedIcon ?? defaultExpandedIcon}</>
          ) : (
            <>{collapsedIcon ?? defaultCollapsedIcon}</>
          )}
          &nbsp;{heading}
        </h4>
        {subheading && <p>{subheading}</p>}
      </div>
      {isExpanded && <div css={styles.collapsibleBody}>{children}</div>}
    </>
  );
};

export default Collapsible;
